<script setup lang="ts">
import { de } from 'date-fns/locale'
import { setDefaultOptions } from 'date-fns'
import './assets/main.css'

setDefaultOptions({ locale: de })

const mainContainer = ref<HTMLDivElement>()

const scrollToTop = () => {
  // Force both documentElement and body scroll to top
  document.documentElement.scrollTo({ top: 0, behavior: 'instant' })
  document.body.scrollTo({ top: 0, behavior: 'instant' })
  // Also set scrollTop as a fallback
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
}

provide('scrollToTop', scrollToTop)

const visualViewportHeight = ref(0)
const searchInputIsVisible = ref(false)
const showSearchInput = () => {
  if (visualViewportHeight.value === 0) {
    visualViewportHeight.value = window.visualViewport?.height || 0
  }
  searchInputIsVisible.value = true
}
const hideSearchInput = () => {
  searchInputIsVisible.value = false
}
const route = useRoute()

setCookie('lexsearch_token', route.query.token as string)

provide('printMode', true)

provide('searchInputIsVisible', searchInputIsVisible)
provide('showSearchInput', showSearchInput)
provide('hideSearchInput', hideSearchInput)
provide('visualViewportHeight', visualViewportHeight)

</script>
<template>
  <div class="flex flex-col w-full min-h-screen print:overflow-visible">
    <div ref="mainContainer" class="flex overflow-y-visible flex-col flex-grow min-h-full mainContainer print:min-h-full print:overflow-y-visible bg-secondary-20 print:bg-white">
      <div class="flex flex-grow justify-center">
        <NuxtPage :keepalive="false" />
      </div>
      <OFFooter />
    </div>
  </div>
</template>
